export default __webpack_public_path__ + "static/media/pdf_icon.3a6f9788.svg";